import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { GALLERY, HERO_IMAGE, PORTRAIT } from "../data/content";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const ASPECT_CLS = { landscape: "aspect-[4/3]", portrait: "aspect-[3/4]", wide: "aspect-[21/9]" };
const SPAN_CLS = { landscape: "md:col-span-6", portrait: "md:col-span-4", wide: "md:col-span-12" };

export const photoUrl = (p) => `${BACKEND}${p.url}`;

const toFrame = (p) => ({
  id: p.id,
  category: p.category,
  title: p.title,
  location: p.location,
  story: p.story,
  aspect: ASPECT_CLS[p.aspect],
  span: SPAN_CLS[p.aspect],
  url: photoUrl(p),
});

export function usePortfolio() {
  const { data } = useQuery({
    queryKey: ["portfolio"],
    queryFn: async () => (await axios.get(`${BACKEND}/api/portfolio`)).data,
  });

  const hasOwn = data?.photos?.length > 0;
  return {
    gallery: hasOwn ? data.photos.map(toFrame) : GALLERY,
    hero: data?.hero ? { url: photoUrl(data.hero), alt: data.hero.title } : HERO_IMAGE,
    portrait: data?.about
      ? { url: photoUrl(data.about), alt: data.about.title, caption: data.about.story || PORTRAIT.caption }
      : PORTRAIT,
    isCustom: hasOwn,
  };
}

export function useBlockedDates() {
  const { data } = useQuery({
    queryKey: ["availability"],
    queryFn: async () => (await axios.get(`${BACKEND}/api/availability`)).data,
  });
  return data ?? [];
}

export function useJournal() {
  return useQuery({
    queryKey: ["journal"],
    queryFn: async () => (await axios.get(`${BACKEND}/api/journal`)).data,
  });
}

export function useStory(slug) {
  return useQuery({
    queryKey: ["journal", slug],
    queryFn: async () => (await axios.get(`${BACKEND}/api/journal/${slug}`)).data,
    retry: false,
  });
}
